import { render, staticRenderFns } from "./MinutesDropdown.vue?vue&type=template&id=975af948&scoped=true&"
import script from "./MinutesDropdown.vue?vue&type=script&lang=js&"
export * from "./MinutesDropdown.vue?vue&type=script&lang=js&"
import style0 from "./MinutesDropdown.vue?vue&type=style&index=0&id=975af948&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975af948",
  null
  
)

export default component.exports